import { useTranslations } from 'next-intl';

import ArticleInfoBar from '../ArticleInfoBar';
import FeaturedImage from '../atoms/FeaturedImage';
import ReadingTime from '../atoms/ReadingTime';

import SpeechSynthesisController from '@components/SpeechSynthesis/SpeechSynthesisControler';

export const HeaderComponent = ({ article, showGraphic, viewReadingTime, viewArticleInfoBar, viewSpeechSynthesis }) => {
  const t = useTranslations();
  const textToSpeechContent = [article.beforeContent, article.content].join(' ');
  return (
    <>
      {showGraphic && (
        <FeaturedImage src={article.featuredImage} caption={article.featuredImageCaption} className="lg:hidden" />
      )}
      <h1 className="mb-4 text-lg font-bold leading-[1.3] text-premium-dark md:text-xl lg:text-[2.125rem] lg:leading-[1.3] dark:text-white">
        {article.title}
      </h1>
      {viewReadingTime || viewSpeechSynthesis ? (
        <div className="mb-4 flex items-center justify-between gap-2 border-b border-t border-ebony border-opacity-20 py-4 lg:justify-start lg:gap-8">
          {viewSpeechSynthesis && <SpeechSynthesisController textToSpeech={textToSpeechContent} />}
          {viewReadingTime && <ReadingTime content={[article.content, article.payContent].join(' ')} />}
        </div>
      ) : (
        <div className="mb-4 border-b border-ebony border-opacity-20"></div>
      )}
      {viewArticleInfoBar && (
        <>
          <ArticleInfoBar
            className="mb-4"
            author={article.author}
            articleDate={article.dateGmt}
            slug={article.slug}
            shareBarTitle={t('main.functionalities.share')}
          />
          <div className="mb-4 border-b border-ebony border-opacity-20"></div>
        </>
      )}
      <p
        className="article-before-content mb-4 font-semibold leading-[1.2] text-premium-900 lg:text-[1.375rem] dark:text-white"
        dangerouslySetInnerHTML={{ __html: article.beforeContent }}
      ></p>
      {showGraphic && (
        <FeaturedImage
          className="mb-4 hidden lg:block"
          src={article.featuredImage}
          caption={article.featuredImageCaption}
        />
      )}
      {article.translation?.translatedByHuman && (
        <div className="relative mx-auto my-4 max-w-[700px] rounded-lg px-8 py-4 text-sm text-premium-dark dark:text-white">
          <div className="absolute inset-0 z-0 rounded-lg bg-premium-900 opacity-10 dark:bg-premium-dark dark:opacity-100"></div>
          <div className="z-2 relative">{t('article.preparedByHuman')}</div>
        </div>
      )}
      {article.translation?.translatedByMachine && (
        <div className="relative mx-auto my-4 max-w-[700px] rounded-lg px-8 py-4 text-sm text-premium-dark dark:text-white">
          <div className="absolute inset-0 z-0 rounded-lg bg-premium-900 opacity-10 dark:bg-premium-dark dark:opacity-100"></div>
          <div className="z-2 relative">{t('article.translatedByMachine')}</div>
        </div>
      )}
    </>
  );
};
